import axios from 'axios';

const outAxios = axios.create({
  baseURL: process.env.ROOT_API,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
  //timeout: 5000,
});

outAxios.interceptors.request.use((config) => {

  //console.log('intercception outAxios')  
  return config

}, function (error) {
  return Promise.reject(error)

});

export default outAxios; 




// WEBPACK FOOTER //
// ./src/plugins/axios2.js